export const FETCH_ALL_CUSTOM_FILEDS = 'FETCH_ALL_CUSTOM_FILEDS';
export const CUSTOM_FIELD_EDITED = 'CUSTOM_FIELD_EDITED';
export const CUSTOM_FIELD_RESET = 'CUSTOM_FIELD_RESET';
export const CUSTOM_FIELD_SAVE = 'CUSTOM_FIELD_SAVE';
export const SAVE_DROPDOWN_OPTIONS = 'SAVE_DROPDOWN_OPTIONS';
export const LOADING = 'LOADING';